<template>
  <v-container primary fill-height fluid>
    <v-layout column align-center>
      <v-flex grow>
        <v-alert
          v-model="isError"
          dismissible
          type="error"
          transition="fade-transition"
        >
          {{ errMessage }}
        </v-alert>
      </v-flex>
      <v-flex mb-3>
        <p style="text-align: center;">
          <img style="max-width: 250px;" src="/img/newfocus-white-text.png" alt="NewFocus Logo" />
        </p>
      </v-flex>
      <v-flex>
        <v-form @submit="submit">
          <v-layout column>
            <v-flex>
              <v-text-field
                v-model="email"
                label="Email Address"
                required
                dark
                :error-messages="errors.email"
                id="email"
                color="secondary"
                @focus="inputFocus"
              ></v-text-field>
              <v-text-field
                v-model="password"
                label="Password"
                type='password'
                required
                dark
                :error-messages="errors.password"
                id="password"
                color="secondary"
                @focus="inputFocus"
              ></v-text-field>
              <v-text-field
                v-model="confirm"
                label="Confirm Password"
                type='password'
                required
                dark
                :error-messages="errors.confirm"
                id="confirm"
                color="secondary"
                @focus="inputFocus"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-layout row>
                <v-flex grow ma-1>
                  <v-btn
                    block
                    dark
                    outline
                    class="secondary"
                    type="submit"
                    id="submit"
                    :disabled="isLoading"
                    :loading="isLoading"
                  >
                    Sign Up
                  </v-btn>
                </v-flex>
                <v-flex grow ma-1>
                  <v-btn
                    block
                    dark
                    outline
                    class="secondary"
                    to="/login"
                    id="login"
                  >
                    Log In
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout row>
                <v-flex grow ma-1 v-if="$root.isGoogleAvailable">
                  <v-btn
                    block
                    dark
                    outline
                    class="secondary"
                    @click="this.$root.googleLogin"
                    id="googleSubmit"
                  >
                    Google Login
                  </v-btn>
                </v-flex>
                <v-flex grow ma-1 v-if="$root.isFacebookAvailable">
                  <v-btn
                    block
                    dark
                    outline
                    class="secondary"
                    @click="this.$root.facebookLogin"
                    id="facebookSubmit"
                  >
                    Facebook Login
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    isLoading: false,
    email: '',
    password: '',
    confirm: '',
    isError: false,
    errMessage: null,
    errors: {
      email: null,
      password: null,
      confirm: null
    }
  }),
  methods: {
    submit (ev) {
      ev.preventDefault()

      this.isLoading = true
      this.$auth.register({
        data: {
          email: this.email,
          password: this.password,
          confirm: this.confirm
        },
        autoLogin: true,
        redirect: '/setup',
        error: this.$root.apiErrorHandler((msg, errors) => {
          this.isLoading = false
          this.errMessage = msg
          this.errors = errors
          this.isError = true
        })
      })
    },
    inputFocus (ev) {
      // Clear any errors for an input when it receives focus
      if (ev.target && ev.target.id) {
        this.errors[ev.target.id] = null
      }
    }
  }
}
</script>
